
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import Head from "next/head"

import SEO from "@/meta/SEO"
import Default from "@/templates/Default"
import ContactPage from "@/views/contact/Contact"

function Contact() {
  return (
    <>
      <Head>
        <title>Kontakt | fansi.pl</title>
        <SEO description="Napisz do nas jeśli potrzebujesz pomocy przy zakupach, masz swoje produkty i chcesz je sprzedawać na fansi lub masz pomysł na autorski produkt i chcesz dowiedzieć się jakie wsparcie możemy Ci zaoferować." />
      </Head>
      <ContactPage />
    </>
  )
}
Contact.Layout = Default
export default Contact


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/contact',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  